import React from 'react';
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import './App.css';
import Story1 from './components/stories/Story1';
import Story2 from './components/stories/Story2';
import Story3 from './components/stories/Story3';
import TicTacToeMinigame from './components/minigames/TicTacToeMinigame';

interface HomeProps {}

const Home: React.FC<HomeProps> = () => {
  const history = useHistory();

  const handlePlayClick = () => {
    history.push('/story1');
  };

  return (
    <div className="App">
      <div className="App-header">
        <h1>Inventress</h1>
        <p>A Parisian Puzzle</p>
        <button className="play-button" onClick={handlePlayClick}>
          Play Now
        </button>
      </div>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/story1" component={Story1} />
        <Route path="/story2" component={Story2} />
        <Route path="/story3" component={Story3} />
        <Route path="/tictactoe" component={TicTacToeMinigame} />
        <Route path="*" render={() => <div>Page not found</div>} />
      </Switch>
    </Router>
  );
};

export default App;